<template>
  <div class="ptqxz-container">
    <sensorView :list="weatherOptions" />
  </div>
</template>

<script>
import singleDeviceMixin from '@/mixins/singleDeviceMixin';
import sensorView from '@/components/sensorList/index.vue';

export default {
  // 气象设备
  name: 'PTQXZ-device',
  mixins: [singleDeviceMixin],
  components: {
    sensorView
  },
  data() {
    return {
      weatherOptions: [
        {
          name: '温度',
          prop: 'temp',
          value: 0,
          unitName: '℃'
        },
        {
          name: '湿度',
          prop: 'humidity',
          value: 0,

          unitName: '%'
        },
        {
          name: '气压',
          prop: 'atm',
          value: 0,

          unitName: 'kPa'
        },
        {
          name: '辐射',
          prop: 'radiation',
          value: 0,
          unitName: 'W/m³'
        },
        {
          name: '风向',
          value: 0,
          prop: 'windDirection',
          unitName: '°'
        },
        {
          name: '风向描述',
          value: '--',
          prop: 'windDirectionValue',
          unitName: ''
        },

        {
          name: '风速',
          value: 0,
          prop: 'windSpeed',
          unitName: 'm/s'
        }
      ]
    };
  },

  methods: {
    unsubscribe() {},
    updateData(res) {
      try {
        let {
          mods: { weatherMod }
        } = res;

        this.weatherOptions.forEach((item, index) => {
          item.alarmState = 0;
          this.$set(this.weatherOptions[index], 'value', weatherMod[item.prop]);
        });
      } catch (error) {
        console.log(error);
      }
    }
  }
};
</script>

<style lang="scss">
.ptqxz-container {
  .common-border {
    height: 100%;
    padding: 2px;
    background-image: url('~@/assets/image/lt.png'), url('~@/assets/image/rt.png'),
      url('~@/assets/image/lb.png'), url('~@/assets/image/rb.png'),
      url('~@/assets/image/linelight.png');
    background-repeat: no-repeat, no-repeat, no-repeat, no-repeat, no-repeat;
    background-position: top left, top right, bottom left, bottom right, center -5px;

    .comp3-content {
      height: 100%;
      box-sizing: border-box;
    }
  }
}
</style>
